module.exports = __webpack_public_path__ + "media/sound1.185cd267.mp3";